import { Tabs } from "@metacrm/metacrm-material-ui/dist/Tabs";
import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import _ from "lodash";
import UserBasicInfo from "./UserBasicInfo";
import UserOnchainData from "./UserOnchainData";
import UserTicketHistory from "./UserTicketHistory";

const UserInfoTabs = ({
  isTicketUserInfo,
  userBasicInfo,
  selectedUserIds,
  isLoading,
}) => {
  const { formatMessage } = useIntl();
  const prevUserIds = useRef(selectedUserIds);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    if (!_.isEqual(prevUserIds.current, selectedUserIds)) {
      setSelectedTab(0);
      prevUserIds.current = selectedUserIds;
    }
  }, [selectedUserIds]);

  const tabs = [
    {
      label: formatMessage({ id: "global.tab.onChainData" }),
      content: (
        <UserOnchainData
          selectedUserIds={selectedUserIds}
          isTicketUserInfo={isTicketUserInfo}
          noOnchainData={userBasicInfo?.wallets?.length === 0}
        />
      ),
    },
    ...(isTicketUserInfo
      ? [
          {
            label: formatMessage({ id: "global.tab.basicInfo" }),
            content: (
              <UserBasicInfo
                isTicketUserInfo={isTicketUserInfo}
                userBasicInfo={userBasicInfo}
                isLoading={isLoading}
              />
            ),
          },
        ]
      : []),
    {
      label: formatMessage({ id: "global.tab.ticketHistory" }),
      content: (
        <UserTicketHistory
          selectedUserIds={selectedUserIds}
          isTicketUserInfo={isTicketUserInfo}
        />
      ),
    },
    // {
    //   label: formatMessage({ id: "global.tab.engagement" }),
    //   content: <Box></Box>,
    // },
  ];

  return (
    <Tabs
      tabLabelStyle={{ fontSize: 12, fontWeight: 500 }}
      value={selectedTab}
      onChange={(e, newValue) => setSelectedTab(newValue)}
      tabs={tabs}
    />
  );
};

export default UserInfoTabs;
